import React, { useState, useEffect } from "react";
import "./UserProfile.css"; // Aquí irán los estilos
import { Typography, Button, Divider, Checkbox, Grid, Grid2, Avatar, ButtonBase } from "@mui/material";
import Header from "../../components/Header.tsx";
import Footer from "../../components/Footer.tsx";
import { useAuth } from "../../components/Auth/AuthContext.tsx";
import { useApi } from "../../services/ApiServices.tsx";
import { Option } from "../../interfaces/SideMenu.interface.ts";
import { useNavigate } from "react-router-dom";
const defaultAvatar = require('../../assets/img/chilin-profile.png');
const chilinTipImage = require('../../assets/img/chilin-alergeno.png');
const chilinEliminarImage = require('../../assets/img/chilin-eliminar.png');

const UserProfile = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { ApiRequest } = useApi();
  const [allergens, setAllergens] = useState<Option[]>([]);
  const [selectedAllergens, setSelectedAllergens] = useState<Option[]>([]);
  const [hasChanges, setHasChanges] = useState(false);
  const [isAlergenos, setIsAlergenos] = useState(true);
  const [isEliminarCuenta, SetIsEliminarCuenta] = useState(false);
  const [recetasFavoritasNumber, setRecetasFavoritosNumber] = useState(0);
  const [tipsFavoritosNumber, setTipsFavoritosNumber] = useState(0);

  useEffect(() => {
    const fetchRecetasFavoritas = async () => {
      //setIsLoadingFavoritas(true);
      if (user) {
        const data = await getRecetasFavoritas();
        setRecetasFavoritosNumber(data.length);
      }
      //setIsLoadingFavoritas(false);
    };

    const fetchTipsFavoritas = async () => {
      //setIsLoadingFavoritas(true);
      if (user) {
        const data = await getTipsFavoritas();
        setTipsFavoritosNumber(data.length);
      }
      //setIsLoadingFavoritas(false);
    };

    if (!user) {
      navigate('/');
    }

    fetchRecetasFavoritas();
    fetchTipsFavoritas();
  }, [user]);

  async function getRecetasFavoritas(): Promise<any[]> {
    try {
      const url = `api/Receta/ListasRecetasFavoritas?email=${user?.email ?? ""}`;
      const data = await ApiRequest(url, 'GET');

      if (data && Array.isArray(data) && data.length > 0) {
        return data;
      } else {
        console.warn('No se recibieron datos válidos en favoritas');
        return [];
      }
    } catch (error) {
      console.error('Error fetching recetas favoritas:', error);
      return [];
    }
  }

  async function getTipsFavoritas(): Promise<any[]> {
    try {
      const url = `api/Tips/ObtenerTipsFavoritos?email=${user?.email ?? ""}`;
      const data = await ApiRequest(url, 'GET');

      if (data && Array.isArray(data) && data.length > 0) {
        return data;
      } else {
        console.warn('No se recibieron datos válidos en favoritas');
        return [];
      }
    } catch (error) {
      console.error('Error fetching recetas favoritas:', error);
      return [];
    }
  }
  useEffect(() => {
    const fetchUserAlergeno = async () => {
      try {
        const data = await ApiRequest(`api/Alergenos/ObtenerAlergenosPorCliente`);
        console.log('alergenos raw', data);
        // Asegurarnos de que selectedAllergens siempre sea un array
        const alergenosArray = Array.isArray(data)
          ? data
          : Array.isArray(data.Alergenos)
            ? data.Alergenos
            : [];
        setSelectedAllergens(alergenosArray);
      } catch (error) {
        console.error('Error fetching recipe details:', error);
      } finally {
        //setIsLoading(false);
        await fetchAlergenos();
      }
    };

    const fetchAlergenos = async () => {
      try {
        const data = await ApiRequest(`api/Catalogo/ListarAlergenos`); // Hacer la solicitud usando el ID
        console.log('alergenos', data);
        setAllergens(data);
      } catch (error) {
        console.error('Error fetching recipe details:', error);
      } finally {
        //setIsLoading(false);
      }
    };

    fetchUserAlergeno();
  }, [ApiRequest, user?.email]);



  const handleCheckboxChange = (allergen: Option) => {
    setSelectedAllergens((prevSelected) => {
      if (prevSelected.some((selected) => selected.id === allergen.id)) {
        // Si ya está seleccionado, eliminarlo
        return prevSelected.filter((selected) => selected.id !== allergen.id);
      } else {
        // Si no está seleccionado, agregarlo
        return [...prevSelected, allergen];
      }
    });
    setHasChanges(true); // Activar botón Guardar si hay cambios
  };

  const handleSaveAlergensToAPI = async () => {
    try {
      const allergensIds = selectedAllergens.map(allergen => allergen.id);
      const body = JSON.stringify({ Email: user?.email ?? "", Alergenos: allergensIds });
      const url = 'api/Alergenos/ActualizarAlergenos';
      await ApiRequest(url, 'POST', body);
    } catch (error) {
      console.error('Error fetching tip:', error);
      return [];
    }
  }

  const handleDeletoToAPI = async () => {
    try {
      const url = `api/Auth/EliminarUsuario?email=${user?.email}`;
      await ApiRequest(url, 'DELETE', null, true);
      logout();
      navigate(`/`);
    } catch (error) {
      console.error('Error fetching tip:', error);
      return [];
    }
  }

  const handleSave = async () => {
    // Lógica para guardar los alérgenos seleccionados
    console.log("Alérgenos guardados:", selectedAllergens);
    await handleSaveAlergensToAPI();
    setHasChanges(false); // Desactivar botón Guardar después de guardar
  };

  const handleDelete = async () => {
    // Lógica para guardar los alérgenos seleccionados
    console.log("Delete");
    await handleDeletoToAPI();
  };

  const resetValues = () => {
    setIsAlergenos(false);
    SetIsEliminarCuenta(false);
  };

  const handleClick = (action) => {
    switch (action) {
      case "recetas":
        console.log("Recetas favoritas clickeado");
        break;
      case "tips":
        console.log("Tips favoritos clickeado");
        break;
      case "promociones":
        console.log("Promociones clickeado");
        break;
      case "alergenos":
        resetValues();
        setIsAlergenos(true);
        console.log("Alérgenos clickeado");
        break;
      case "eliminar":
        resetValues();
        SetIsEliminarCuenta(true);
        console.log("Eliminar cuenta clickeado");
        break;
      default:
        console.log("Acción no definida");
    }
  };

  return (
    <Grid2>
      <Header />
      <Grid2 container className="profile-container">
        {/* Contenedor Izquierdo */}
        <Grid2 size={{ sm: 12, md: 4 }} className="profile-left">
          {/* Foto, Nombre y Mail */}
          <Grid2 className="user-info">
            <Avatar
              src={user?.avatar || defaultAvatar}
              alt={user?.name}
              sx={{ width: 146, height: 146, marginRight: '8px' }}
            />
            <Typography className="user-name">{user?.name}</Typography>
            <Typography className="user-email">{user?.email}</Typography>
          </Grid2>

          <Divider className="divider" />

          {/* Opciones */}
          <Grid2 className="user-options">
            <ButtonBase className="option-row" onClick={() => handleClick("recetas")}>
              <Typography>Recetas favoritas</Typography>
              <Typography>{recetasFavoritasNumber}</Typography>
            </ButtonBase>
            <ButtonBase className="option-row" onClick={() => handleClick("tips")}>
              <Typography>Tips favoritos</Typography>
              <Typography>{tipsFavoritosNumber}</Typography>
            </ButtonBase>
          </Grid2>

          <Divider className="divider" />

          <Grid2 className="user-options">
            <ButtonBase className="option-row" onClick={() => handleClick("promociones")}>
              <Typography>Promociones</Typography>
              <Typography>-</Typography>
            </ButtonBase>
          </Grid2>

          <Divider className="divider" />

          {/* Alérgenos */}
          <ButtonBase className="option-row" onClick={() => handleClick("alergenos")}>
            <Typography className="section-title-left">Alérgenos</Typography>
            <Typography className="allergen-status">
              {selectedAllergens.length > 0 ? "Sí" : "No"} {">"}
            </Typography>
          </ButtonBase>

          <Divider className="divider" />

          <Grid2 className="user-options">
            <ButtonBase className="option-row" onClick={() => handleClick("eliminar")}>
              <Typography>Eliminar cuenta</Typography>
            </ButtonBase>
          </Grid2>



        </Grid2>

        <Grid2 size={{ sm: 12, md: 6 }}>
          {/* Contenedor Derecho */}
          {isAlergenos ? (
            <Grid2 className="profile-right">
              <Grid2 className="allergen-list">
                <Typography className="section-title">Alérgenos</Typography>
                <Grid2 size={12} container>
                  <Grid2 size={7} container spacing={2}>
                    {allergens.map((allergen, index) => (
                      <Grid2 size={6} key={index}>
                        <Grid2 className="allergen-item">
                          <Checkbox
                            checked={selectedAllergens.some((selected) => selected.id === allergen.id)}
                            onChange={() => handleCheckboxChange(allergen)}
                          />
                          <Typography>{allergen.nombre}</Typography>
                        </Grid2>
                      </Grid2>
                    ))}
                  </Grid2>
                  <Grid2 size={4}>
                    <Grid2 className="image-container">
                      <img
                        src={chilinTipImage}
                        alt="Alergeno"
                        className="decorative-image"
                      />
                    </Grid2>
                  </Grid2>
                </Grid2>
              </Grid2>

            </Grid2>
          ) : isEliminarCuenta ? (
            <Grid2 className="profile-right">
              <Grid2 className="allergen-list">
                <Typography className="section-title">Eliminar cuenta</Typography>

                <Typography className="text-eliminar">¿Realmente quieres eliminar tu cuenta?</Typography>

                <Typography className="text-eliminar">
                  Eliminar tu cuenta es una decisión importante y no se puede deshacer. Perderás acceso a todos tus datos y contenido asociado. Si estás seguro de continuar, por favor confirma tu decisión. ¡Te extrañaremos!
                </Typography>

                <Grid2 className="image-container">
                  <img
                    src={chilinEliminarImage}
                    alt="Eliminar"
                    className="decorative-image"
                  />
                </Grid2>

              </Grid2>
            </Grid2>

          ) : (
            <Divider />
          )}
        </Grid2>


      </Grid2>
      {/* Botón Guardar */}
      {isAlergenos ? (
        <Grid2 className="save-button-container">
          <Button
            variant="contained"
            color="primary"
            className="save-button"
            onClick={handleSave}
            disabled={!hasChanges}
          >
            Guardar
          </Button>
        </Grid2>
      ) : isEliminarCuenta ? (
        <Grid2 className="save-button-container">
          <Button
            variant="contained"
            color="primary"
            className="save-button"
            onClick={handleDelete}
          >
            Eliminar cuenta
          </Button>
        </Grid2>
      ) : (
        <Divider />
      )}

      <Footer />
    </Grid2>
  );
};

export default UserProfile;
